import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import { colors, fonts } from '../../styles/theme';

interface LoadingStateProps {
  message?: string;
  fullScreen?: boolean;
  subtitle?: string;
}

/**
 * Wiederverwendbare Loading-State Komponente
 */
const LoadingState: React.FC<LoadingStateProps> = ({
  message = "Wird geladen...",
  fullScreen = false,
  subtitle = "Bitte warten Sie einen Moment."
}) => {
  if (fullScreen) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          background: `linear-gradient(135deg, ${colors.background} 0%, ${colors.primary} 100%)`,
          padding: 2
        }}
      >
        <Box
          sx={{
            textAlign: 'center',
            background: colors.glass.backgroundStrong,
            padding: 4,
            borderRadius: 3,
            backdropFilter: 'blur(10px)',
            border: `1px solid ${colors.glass.borderSubtle}`,
            maxWidth: 400,
            width: '100%'
          }}
        >
          <CircularProgress
            size={60}
            sx={{
              color: colors.primary,
              mb: 2
            }}
          />
          <Typography
            variant="h6"
            sx={{
              fontFamily: fonts.monospace,
              color: colors.text.primary,
              mb: 1
            }}
          >
            {message}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: colors.text.secondary,
              fontSize: '0.9rem'
            }}
          >
            {subtitle}
          </Typography>
        </Box>
      </Box>
    );
  }

  // Einfacher Inline-Loading-State
  return (
    <Box sx={{ mb: 2, textAlign: 'center' }}>
      <Typography>{message}</Typography>
    </Box>
  );
};

export default LoadingState;
